"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTA9 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
// inline with two buttons
var CTA9 = function (_a) {
    var heading = _a.heading, paragraph = _a.paragraph, primary = _a.primary, primaryLink = _a.primaryLink, secondary = _a.secondary, secondaryLink = _a.secondaryLink;
    return ((0, jsx_runtime_1.jsx)("section", __assign({ className: "section-padding-xs bg-dark-secondary" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "d-lg-flex align-items-center" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "me-lg-auto mb-6 mb-lg-0" }, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ className: "mb-4" }, { children: heading })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "fw-light opacity-60 mb-0" }, { children: paragraph }))] })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Button, __assign({ href: secondaryLink, size: "lg", color: "darker-primary", className: "rounded-pill d-block d-sm-inline-block me-sm-4 mb-3 mb-sm-0" }, { children: secondary })), (0, jsx_runtime_1.jsx)(reactstrap_1.Button, __assign({ href: primaryLink, size: "lg", color: "light", className: "rounded-pill d-block d-sm-inline-block" }, { children: primary }))] })] })) })) })));
};
exports.CTA9 = CTA9;
